/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feOctagon', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherOctagonIconData */

/** @type {FeatherOctagonIconData} */
const feOctagon = {
  prefix: 'fe',
  iconName: 'octagon',
  icon: [
    24,
    24,
    '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-octagon"><path d="M7.86 2 L16.14 2 L22 7.86 L22 16.14 L16.14 22 L7.86 22 L2 16.14 L2 7.86 L7.86 2 Z"/></svg>',
    'M7.86 2 L16.14 2 L22 7.86 L22 16.14 L16.14 22 L7.86 22 L2 16.14 L2 7.86 L7.86 2 Z',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feOctagon
